import React from 'react';
import i18n from '../../../../../i18n';
import type { DrillImpact } from '../../../types';
import '../../../styles/drill-noshow.css';

/**
 * Guests lost to no-shows / cancellations and what they are worth, under the
 * drill hero. The text is the backend's (it names the spend basis); nothing
 * renders when the payload has no impact.
 */
export function DrillImpactLine({ impact }: { impact?: DrillImpact | null }) {
  if (!impact?.items?.length) return null;
  return (
    <div
      className="ddrill-impact"
      role="note"
      aria-label={i18n.t('performance:noshowSubstance.impactAria')}
      data-testid="drill-impact"
    >
      <p className="ddrill-impact-items">
        {impact.items.map(item => (
          <span key={item.metricKey}>{item.text}</span>
        ))}
      </p>
      <p className="ddrill-impact-basis">{impact.basis.text}</p>
    </div>
  );
}
